import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "taskStatus",
  standalone: true,
})
export class TaskStatusPipe implements PipeTransform {
  // #region Public Methods (1)

  public transform(value: any, args?: any): any {
    switch (value.toLowerCase()) {
      case "new":
        return "New";
      case "in progress":
        return "In Progress";
      case "blocked":
        return "blocked";
      case "done":
        return "done";
    }
    return value;
  }

  // #endregion Public Methods (1)
}
